import type { ApiResponse, ShopSettings, UpdateShopSettingsInput } from '@cracked-mug/shared';
import { api } from './api';

function unwrap<T>(payload: ApiResponse<T>): T {
  if (!payload.success) {
    throw new Error(payload.error);
  }
  return payload.data;
}

export async function fetchSettings(): Promise<ShopSettings> {
  const res = await api.get<ApiResponse<ShopSettings>>('/settings');
  return unwrap(res.data);
}

export async function updateSettings(input: UpdateShopSettingsInput): Promise<ShopSettings> {
  const res = await api.put<ApiResponse<ShopSettings>>('/settings', input);
  return unwrap(res.data);
}

/**
 * Narrow shop-open toggle accessible to both admins and baristas. Used by
 * the Kitchen page so the kid on duty can flip "open" without admin access.
 */
export async function setShopOpen(isOpen: boolean): Promise<ShopSettings> {
  const res = await api.patch<ApiResponse<ShopSettings>>('/settings/open', { isOpen });
  return unwrap(res.data);
}
